export const SITE_URL = "https://leanylabs.com";
export const CAPTCHA_KEY = "6LenlacZAAAAAJjPBFxU62FUnDamg42y0QDH_Hw0";
export const GTAG_IDS = ["UA-168142002-2", "G-FQJHB79PRF"];
export const CONSENT_KEY = "cookieConsent";

export const CONTACT_US_PERSON_URL = "https://www.linkedin.com/in/mykola-pustovoychenko-b7788051/";
export const CONTACT_US_PERSON_NAME = "Mykola Pustovoychenko";
export const CONTACT_US_PERSON_EMAIL = "mykola@leanylabs.com";
export const CONTACT_US_BOOK_CALL_URL = "https://calendly.com/mykola-pustovoychenko/leanylabs-intro";